import Action from "@/classes/Action.js"
import Runnable from "@/classes/Runnable.js"

class ActionIfCoins extends Action {
	static _group = Action.GROUP.flow_control;
	static _label = "Condizione Monete";
	static _fields = {
		comparison: {
			label: "Comparatore",
			type: "select",
			value: "eq",
			options: ActionIfCoins._comparisonsEx
		},
		value: {
			label: "Valore",
			type: "number",
			value: 0
		},
	};

	get abstract() {
		return "Monete "
			+ ActionIfCoins._comparisons[this.data.comparison.value] + " "
			+ this.data.value.value
		;
	}

	// ###

	action() {
		const v = this.container.figure.data.coins;
		let f = false;
		switch (this.data.comparison.value) {
			case "eq":
				f = (v == this.data.value.value);
				break;
			case "ne":
				f = (v != this.data.value.value);
				break;
			case "gt":
				f = (v > this.data.value.value);
				break;
			case "ge":
				f = (v >= this.data.value.value);
				break;
			case "lt":
				f = (v < this.data.value.value);
				break;
			case "le":
				f = (v <= this.data.value.value);
				break;
		}
		return (f ? null : Runnable.JUMP);
	}
}

export default ActionIfCoins;
